import { Box, Skeleton } from '@mui/material';
import React from 'react';

export const ChatSkeleton: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        p: 2,
        gap: 3,
        bgcolor: '#f9fafb',
      }}
    >
      <Box
        sx={{
          bgcolor: 'white',
          p: 2,
          borderRadius: 3,
          border: '1px solid',
          borderColor: '#e3f2fd',
        }}
      >
        <Skeleton variant='text' width='40%' height={20} sx={{ mb: 2 }} />
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
          <Skeleton variant='text' width='80%' height={16} />
          <Skeleton variant='text' width='80%' height={16} />
          <Skeleton variant='text' width='80%' height={16} />
          <Skeleton variant='text' width='80%' height={16} />
        </Box>
        <Skeleton
          variant='rectangular'
          width='100%'
          height={60}
          sx={{ mt: 2, borderRadius: 1 }}
        />
      </Box>

      <Box
        sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 2 }}
      >
        <Skeleton
          variant='text'
          width='60%'
          height={16}
          sx={{ alignSelf: 'center', mb: 2 }}
        />

        {[1, 2, 3, 4].map((index: number) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              justifyContent: index % 2 === 0 ? 'flex-start' : 'flex-end',
            }}
          >
            <Box
              sx={{
                maxWidth: '70%',
                display: 'flex',
                flexDirection: 'column',
                gap: 0.5,
              }}
            >
              <Skeleton variant='text' width={80} height={14} />
              <Skeleton
                variant='rectangular'
                width={index % 2 === 0 ? 280 : 220}
                height={index === 2 ? 80 : 60}
                sx={{ borderRadius: 2 }}
              />
              <Skeleton variant='text' width={60} height={12} />
            </Box>
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          borderTop: '1px solid',
          borderColor: '#eeeeee',
          pt: 2,
          bgcolor: 'white',
        }}
      >
        <Skeleton
          variant='rectangular'
          width='100%'
          height={48}
          sx={{ borderRadius: 1 }}
        />
      </Box>
    </Box>
  );
};
